import React from "react";
import styled from "styled-components";
import { useState, useRef } from "react";
import imageUploader from "../lib/imageUploader";
import { color, flexCenter } from "../styles/theme";

const ImageUploaderVanila = ({ onChangeHandler }: any) => {
	const [image, setImage] = useState();
	const [viewImage, setViewImage] = useState<any>();
	const inputRef = useRef<any>();

	const onFileChange = async (event: any) => {
		event.preventDefault();
		const reader = new FileReader();
		reader.onload = (event: any) => {
			setViewImage(event.target.result);
		};
		// event.current.value = "";
		reader.readAsDataURL(event.target.files[0]);

		onChangeHandler(event.target.files[0], "image");

		setImage(event.target.files[0]);
	};

	// const submit = async () => {

	// 	//이미지 유알엘 디비로 전달
	// 	console.log("uploaded", uploaded);
	// };

	return (
		<ImageUploaderBox>
			{viewImage ? (
				<div>
					<img src={viewImage} alt="img" />
					<input
						className="imgInput"
						ref={inputRef}
						onChange={onFileChange}
						type="file"
						accept="image/*"
						name="file"
					/>
				</div>
			) : (
				<div>
					<input
						id="file"
						ref={inputRef}
						onChange={onFileChange}
						type="file"
						accept="image/*"
						name="file"
					/>
					<label htmlFor="file">File Choose</label>
				</div>
			)}
			{/* <button onClick={submit}>submit</button> */}
		</ImageUploaderBox>
	);
};

const ImageUploaderBox = styled.div`
	${flexCenter}
	align-items: center;
	min-width: 7rem;
	min-height: 7rem;
	max-width: 7rem;
	max-height: 7rem;
	border: 3px solid ${color.green};
	padding: 0;

	img {
		min-width: 7rem;
		min-height: 7rem;
		max-width: 7rem;
		max-height: 7rem;
		margin: 0;
	}

	div {
		width: 100%;
		height: 100%;
	}

	input {
		display: none;
		min-width: 7rem;
		min-height: 7rem;
		max-width: 7rem;
		max-height: 7rem;
	}

	label {
		display: flex;
		align-items: center;
		height: 100%;
		width: 100%;
		cursor: pointer;
	}
`;

export default ImageUploaderVanila;
